module.exports = __webpack_public_path__ + "media/components/country-flag/static/st-12444111a834c4924ca5a5d6c8bbb10a.svg";